import { Building2, FileText, Mail, MapPin, Phone, UserRound } from "lucide-react";
import InfoRow from "./InfoRow";
import StatusBadge from "./StatusBadge";

export default function ClientSummaryCard({ client }) {
  return (
    <aside className="h-fit rounded-2xl border border-slate-200 bg-white p-5 shadow-sm lg:sticky lg:top-6">
      <div className="mb-5 border-b border-slate-100 pb-4">
        <div className="mb-2 flex items-center gap-2">
          <Building2 size={18} className="text-slate-500" />
          <h2 className="text-lg font-semibold text-slate-900">{client.bedrijfsnaam}</h2>
        </div>
        <div className="mb-3 flex items-center gap-2 text-sm text-slate-500">
          <span>Klantnummer {client.klantnummer}</span>
        </div>
        <StatusBadge value={client.status} />
      </div>

      <div className="space-y-1">
        <InfoRow label="Bezoekadres" value={client.bezoekadres} />
        <InfoRow label="Factuuradres" value={client.factuuradres} />
        <InfoRow label="KVK" value={client.kvkNummer} />
        <InfoRow label="BTW" value={client.btwNummer} />
      </div>

      <div className="my-4 h-px bg-slate-100" />

      <div className="space-y-2 text-sm text-slate-700">
        <div className="flex items-center gap-2">
          <UserRound size={15} className="text-slate-500" />
          <span>{client.hoofdcontactpersoon || "Geen hoofdcontactpersoon"}</span>
        </div>
        <div className="flex items-center gap-2">
          <Phone size={15} className="text-slate-500" />
          <span>{client.telefoon || "-"}</span>
        </div>
        <div className="flex items-center gap-2">
          <Mail size={15} className="text-slate-500" />
          <span>{client.email || "-"}</span>
        </div>
        <div className="flex items-center gap-2">
          <MapPin size={15} className="text-slate-500" />
          <span className="capitalize">Klanttype: {client.klanttype}</span>
        </div>
      </div>

      <div className="my-4 h-px bg-slate-100" />

      <div className="space-y-3 rounded-xl bg-slate-50 p-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-slate-700">
          <FileText size={15} />
          <span>Documenten</span>
        </div>
        <p className="text-xs text-slate-600">
          {client.documentSamenvatting.totaal} totaal, {client.documentSamenvatting.verlopenBinnenkort} verlopen binnenkort, {" "}
          {client.documentSamenvatting.ontbrekend} ontbrekend
        </p>
        <p className="text-xs text-slate-600">{client.contactSamenvatting}</p>
      </div>
    </aside>
  );
}
